import { useTranslation } from 'react-i18next';
import LandingLayout from '../components/LandingLayout';

export default function PrivacyPage() {
  const { t } = useTranslation();

  return (
    <LandingLayout>
      <div className="min-h-screen bg-dark-950 py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-extrabold mb-4 text-white">
            {t('legal.privacy.title')}
          </h1>
          <p className="text-gray-400 mb-12">
            {t('legal.privacy.lastUpdated')}: {t('legal.privacy.lastUpdatedDate')}
          </p>

          <div className="space-y-12 text-gray-300">
            {/* Introduction */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">
                {t('legal.privacy.sections.intro.title')}
              </h2>
              <p className="leading-relaxed">
                {t('legal.privacy.sections.intro.content')}
              </p>
            </section>

            {/* Data We Collect */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">
                {t('legal.privacy.sections.collect.title')}
              </h2>
              <div className="space-y-4">
                <p className="leading-relaxed">
                  {t('legal.privacy.sections.collect.content')}
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>{t('legal.privacy.sections.collect.item1')}</li>
                  <li>{t('legal.privacy.sections.collect.item2')}</li>
                  <li>{t('legal.privacy.sections.collect.item3')}</li>
                  <li>{t('legal.privacy.sections.collect.item4')}</li>
                </ul>
              </div>
            </section>

            {/* How We Use Data */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">
                {t('legal.privacy.sections.use.title')}
              </h2>
              <div className="space-y-4">
                <p className="leading-relaxed">
                  {t('legal.privacy.sections.use.content')}
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>{t('legal.privacy.sections.use.item1')}</li>
                  <li>{t('legal.privacy.sections.use.item2')}</li>
                  <li>{t('legal.privacy.sections.use.item3')}</li>
                  <li>{t('legal.privacy.sections.use.item4')}</li>
                </ul>
              </div>
            </section>

            {/* Data Sharing */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">
                {t('legal.privacy.sections.sharing.title')}
              </h2>
              <p className="leading-relaxed">
                {t('legal.privacy.sections.sharing.content')}
              </p>
            </section>

            {/* Data Security */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">
                {t('legal.privacy.sections.security.title')}
              </h2>
              <p className="leading-relaxed">
                {t('legal.privacy.sections.security.content')}
              </p>
            </section>

            {/* Cookies */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">
                {t('legal.privacy.sections.cookies.title')}
              </h2>
              <p className="leading-relaxed">
                {t('legal.privacy.sections.cookies.content')}
              </p>
            </section>

            {/* Your Rights */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">
                {t('legal.privacy.sections.rights.title')}
              </h2>
              <div className="space-y-4">
                <p className="leading-relaxed">
                  {t('legal.privacy.sections.rights.content')}
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>{t('legal.privacy.sections.rights.item1')}</li>
                  <li>{t('legal.privacy.sections.rights.item2')}</li>
                  <li>{t('legal.privacy.sections.rights.item3')}</li>
                  <li>{t('legal.privacy.sections.rights.item4')}</li>
                </ul>
              </div>
            </section>

            {/* Data Retention */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">
                {t('legal.privacy.sections.retention.title')}
              </h2>
              <p className="leading-relaxed">
                {t('legal.privacy.sections.retention.content')}
              </p>
            </section>

            {/* Changes to Policy */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">
                {t('legal.privacy.sections.changes.title')}
              </h2>
              <p className="leading-relaxed">
                {t('legal.privacy.sections.changes.content')}
              </p>
            </section>

            {/* Contact */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">
                {t('legal.privacy.sections.contact.title')}
              </h2>
              <p className="leading-relaxed">
                {t('legal.privacy.sections.contact.content')}
              </p>
              <p className="mt-4 text-primary-400">
                {t('legal.contact.email')}
              </p>
            </section>
          </div>
        </div>
      </div>
    </LandingLayout>
  );
}
